export default "__VITE_ASSET__CG8sl5bm__"